import { EWalletTypeEnum } from '#lib/enums'
import type {
  DepositStoreState,
  EWalletItem,
  EWalletResponseItem,
} from '#lib/types'

export const EWALLET_OPTIONS: EWalletItem[] = [
  {
    label: 'MoMo',
    value: EWalletTypeEnum.Momo,
    isMaintainance: false,
    items: [],
  },
  {
    label: 'Viettel Money',
    value: EWalletTypeEnum.ViettelPay,
    isMaintainance: true,
    items: [],
  },
]

export const DEFAULT_DEPOSIT_STORE_STATE: DepositStoreState = {
  fastpayCode: '',
  phoneCardProviders: [],
  withdrawBanks: [],
  depositFastPays: [],
  bankSchedules: [],
  cryptos: [],
  cryptoTimeLeft: 0,
  isMaintainedPhoneCardWithdraw: false,
  paywinBanks: [],
  eWallets: EWALLET_OPTIONS,
  eWalletCode: '',
  isFetchData: false,
}

export const PRIORITY_BANKS = [
  {
    bank_code: 'Eximbank',
  },
  {
    bank_code: 'Sacombank',
  },
  {
    bank_code: 'Techcombank',
  },
  {
    bank_code: 'PVcombank',
  },
  {
    bank_code: 'VietCapital',
  },
  {
    bank_code: 'VPbank',
  },
]

export const E_WALLET_EMPTY_INFO: EWalletResponseItem = {
  account_name: '',
  account_no: '',
  bank_code: '',
  branch_name: '',
  qr_code: '',
}

export const E_WALLET_TYPES = {
  MOMO: 'momo',
  VIETTEL_PAY: 'viettelpay',
}
